/**
 * @generated SignedSource<<d938781459f8eebe36d89eb762976daa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type AppComponentBetUpdatedSubscription$variables = {};
export type AppComponentBetUpdatedSubscription$data = {
  readonly betUpdated: {
    readonly gameId: string;
    readonly gameProvider: string;
    readonly currency: string;
    readonly virtualId: number;
    readonly finished: boolean;
    readonly bets: ReadonlyArray<number>;
    readonly win: number | null;
    readonly btcBet: number | null;
    readonly btcWin: number | null;
    readonly multiplier: number;
    readonly meta: any | null;
    readonly insertedAt: string;
    readonly normalizedGame: {
      readonly label: string;
      readonly gameId: string;
      readonly provider: string | null;
    } | null;
    readonly user: {
      readonly uuid: string | null;
      readonly name: string;
      readonly hasProfileImage: boolean;
    };
  } | null;
};
export type AppComponentBetUpdatedSubscription = {
  variables: AppComponentBetUpdatedSubscription$variables;
  response: AppComponentBetUpdatedSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameId",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GameBet",
    "kind": "LinkedField",
    "name": "betUpdated",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gameProvider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "virtualId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finished",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bets",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "win",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "btcBet",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "btcWin",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "multiplier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "meta",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "insertedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NormalizedGame",
        "kind": "LinkedField",
        "name": "normalizedGame",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BetUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasProfileImage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppComponentBetUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppComponentBetUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e04529012028414fbf65cfad1e51cb8",
    "id": null,
    "metadata": {},
    "name": "AppComponentBetUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription AppComponentBetUpdatedSubscription {\n  betUpdated {\n    gameId\n    gameProvider\n    currency\n    virtualId\n    finished\n    bets\n    win\n    btcBet\n    btcWin\n    multiplier\n    meta\n    insertedAt\n    normalizedGame {\n      label\n      gameId\n      provider\n    }\n    user {\n      uuid\n      name\n      hasProfileImage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e26d5a19a3a642145f33e06d1d56b241";

export default node;
